<button (click)="onClick()" mat-menu-item [disabled]="disabled">
    <p [class.disabled]="disabled">{{ item?.label | transloco }}</p>
</button>
